//トップページ　キービジュアルスライダー

export function recruitFunc() {
  let recruitTop = $("#recruitTop").length;

  if(recruitTop){

    //オーディオの同時再生禁止
    document.addEventListener('play', (e) => {
      const audios = document.querySelectorAll('audio');
      audios.forEach((audio) => {
        if(audio !== e.target) {
          audio.pause();
        }
      });
    }, true);

  }
}